import React from 'react';
import { Settings, Clock, Mail } from 'lucide-react';

const MaintenancePage = ({ message, estimatedTime }) => {
    return (
        <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-6 font-sans">
            <div className="max-w-md w-full">
                {/* Header Sequence */}
                <div className="text-center mb-10">
                    {/* SB Cards Logo */}
                    <div className="inline-flex items-center gap-2 mb-8 px-4 py-2 bg-indigo-50 rounded-full border border-indigo-100">
                        <div className="w-6 h-6 bg-indigo-600 rounded-md flex items-center justify-center text-white font-bold text-[10px] tracking-wider">
                            SB
                        </div>
                        <span className="text-sm font-bold text-indigo-900 tracking-wide">SB CARDS</span>
                    </div>

                    <div className="flex justify-center mb-6">
                        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-slate-100 text-slate-500 shadow-sm border border-slate-200">
                            <Settings className="w-8 h-8 animate-[spin_10s_linear_infinite]" />
                        </div>
                    </div>
                    <h1 className="text-3xl font-bold text-slate-900 mb-3 tracking-tight">
                        We'll be back soon
                    </h1>
                    <p className="text-slate-600 text-base leading-relaxed max-w-sm mx-auto">
                        {message || "We are currently performing scheduled maintenance to improve our systems. We apologize for the inconvenience."}
                    </p>
                </div>

                {/* Status Card */}
                <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 mb-8 max-w-sm mx-auto">
                    <div className="space-y-4">
                        <div className="flex items-center justify-between">
                            <span className="text-sm font-medium text-slate-500">Status</span>
                            <div className="flex items-center gap-2">
                                <span className="relative flex h-2.5 w-2.5">
                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                                    <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-amber-500"></span>
                                </span>
                                <span className="text-sm font-semibold text-amber-600">Team is working on it</span>
                            </div>
                        </div>

                        {estimatedTime && (
                            <>
                                <div className="h-px bg-slate-100 w-full"></div>
                                <div className="flex items-center justify-between">
                                    <span className="text-sm font-medium text-slate-500">Est. completion</span>
                                    <div className="flex items-center gap-1.5 text-sm font-semibold text-slate-700">
                                        <Clock className="w-4 h-4 text-slate-400" />
                                        <span>{estimatedTime}</span>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                {/* Footer / Contact */}
                <div className="text-center">
                    <p className="text-sm text-slate-500 mb-2">Need urgent assistance?</p>
                    <a
                        href="mailto:support@cards.sbdev.in"
                        className="inline-flex items-center gap-2 text-sm font-medium text-indigo-600 hover:text-indigo-700 hover:underline transition-all"
                    >
                        <Mail className="w-4 h-4" />
                        support@cards.sbdev.in
                    </a>
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;
